const semanticClassNames = {
  root: 'hamburger-menu-container',
} as const;

export default semanticClassNames;
